import React from 'react';
import {
  Box,
  VStack,
  HStack,
  Heading,
  Text,
  SimpleGrid,
  Icon,
  useColorModeValue,
} from '@chakra-ui/react';
import { FaCheck } from 'react-icons/fa';

interface CoreValuesPresentationProps {
  values: string[];
}

const CoreValuesPresentation: React.FC<CoreValuesPresentationProps> = ({
  values
}) => {
  const cardBg = useColorModeValue('white', 'gray.700');

  return (
    <Box width="full">
      <VStack spacing={8} mb={12} textAlign="center" maxW="800px" mx="auto">
        <Heading as="h3" size="lg" color="brand.primary.dark">
          Our Core Values
        </Heading>
      </VStack>
      
      <Box 
        bg={cardBg} 
        p={8} 
        borderRadius="lg" 
        boxShadow="md"
        maxW="800px"
        mx="auto"
      >
        <SimpleGrid columns={{ base: 1, md: 2 }} spacing={6}>
          {values.map((value: string, index: number) => (
            <HStack key={index} align="flex-start">
              <Box color="brand.primary.base" pt={1}>
                <Icon as={FaCheck} />
              </Box>
              <Text>{value}</Text>
            </HStack>
          ))}
        </SimpleGrid>
      </Box>
    </Box>
  );
};

export default CoreValuesPresentation;